<template>
  <PageNavigation />
  <div ref="pageView" :class="{ 'panel-shell': $route.path.startsWith('/panel'), 'panel-shell--collapsed': panelLayout.collapsed }"><router-view /></div>
  <CartSticky v-if="!$route.meta.panelWorkspace" />
  <CallbackModal />
  <CookieConsentBanner />
</template>

<script>
import { panelLayout } from './utils/panelLayout'
import CartSticky from './components/elements/Shop/CartSticky.vue'
import CallbackModal from './components/elements/CallbackModal.vue'
import CookieConsentBanner from './components/elements/CookieConsentBanner.vue'
import PageNavigation from './components/elements/PageNavigation.vue'

export default {
  data: () => ({ panelLayout }),
  components: { CartSticky, CallbackModal, CookieConsentBanner, PageNavigation },
  watch: {
    '$route.path': async function (path, previousPath) {
      if (!previousPath) return
      await this.$nextTick()
      if (this.$route.path !== path || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
      const content = this.$refs.pageView?.querySelector('.content')
      content?.animate?.([{ opacity: 0.55 }, { opacity: 1 }], { duration: 160, easing: 'ease-out' })
    }
  }
}
</script>
